import { render, staticRenderFns } from "./EditInjection.vue?vue&type=template&id=592e53e6&scoped=true"
import script from "./EditInjection.vue?vue&type=script&lang=js"
export * from "./EditInjection.vue?vue&type=script&lang=js"
import style0 from "./EditInjection.vue?vue&type=style&index=0&id=592e53e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e53e6",
  null
  
)

export default component.exports